import { useEffect, useState, useCallback } from 'react';
import { getValidRegion } from 'src/utils/region-utils';
import { useFeatureFlag } from 'src/utils/useFeatureFlag';

const STAGE: string = "Gamma";
const VALID_REGIONS = ['NA', 'EU', 'FE', 'CN'];

const removeWidgetElements = () => {
    document.getElementById('transxray-widget-frame')?.remove();
    document.getElementById('transxray-widget-btn')?.remove();
};

export const TransXRayWidget = () => {
    const [region, setRegion] = useState(getValidRegion());
    const isEnabled = useFeatureFlag('txray-widget');

    const syncRegion = useCallback(() => {
        const params = new URLSearchParams(window.location.search);
        const urlRegion = params.get('region') || 'NA';
        const validated = VALID_REGIONS.includes(urlRegion) ? urlRegion : 'NA';
        setRegion(validated);
    }, []);

    useEffect(() => {
        const origPushState = window.history.pushState.bind(window.history);
        window.history.pushState = (...args: Parameters<typeof origPushState>) => {
            origPushState(...args);
            syncRegion();
        };

        window.addEventListener('popstate', syncRegion);
        return () => {
            window.history.pushState = origPushState;
            window.removeEventListener('popstate', syncRegion);
        };
    }, [syncRegion]);

    useEffect(() => {
        if (!isEnabled || region === 'FE' || region === 'CN') {
            removeWidgetElements();
            return;
        }

        const stagePrefix = STAGE.toLowerCase() === 'prod' ? 'prod' : 'gamma';
        const regionLower = region.toLowerCase();
        const script = document.createElement('script');
        script.src = `https://${stagePrefix}.${regionLower}.sauron.transportation.amazon.dev/widget/loader.js`;
        script.setAttribute('data-button-margin-bottom', '70');
        script.setAttribute('data-button-margin-right', '20');
        document.body.appendChild(script);

        return () => {
            script.parentNode?.removeChild(script);
            removeWidgetElements();
        };
    }, [region, isEnabled]);

    return null;
};

export default TransXRayWidget;
